import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";
import "../styles/Formularios.css";
import RastrearRed from "./RastrearRed";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";
import ReporteSw from "./ReporteSw";
import ReportePp from "./ReportePp";

function ReporteInfra({ setVista }) {

    const [vistaLocal, setVistaLocal] = useState("botones");

    return (
        <div className="sesion-form">
            {vistaLocal === "botones" && (
                <>
                    <div className="reportes-botones">
                        <button onClick={() => setVistaLocal("sw")}>Consultar<br></br>switches</button>
                        <button onClick={() => setVistaLocal("pp")}>Consultar<br></br>patch panels</button>
                    </div>

                    <div className="form-buttons">
                        <button onClick={() => {
                            setVista("red")
                        }}>
                            Volver
                        </button>
                    </div>
                </>
            )}

            {vistaLocal === "sw" && (
                <>
                    <ReporteSw />

                    <div className="form-buttons">
                        <button onClick={() => {
                            setVistaLocal("botones")
                        }}>
                            Volver
                        </button>
                    </div>
                </>
            )}

            {vistaLocal === "pp" && (
                <>
                    <ReportePp />

                    <div className="form-buttons">
                        <button onClick={() => {
                            setVistaLocal("botones")
                        }}>
                            Volver
                        </button>
                    </div>
                </>
            )}

        </div >
    );
}

export default ReporteInfra;